import { render, staticRenderFns } from "./riskAndDangerDialog.vue?vue&type=template&id=480a6072&scoped=true&"
import script from "./riskAndDangerDialog.vue?vue&type=script&lang=ts&"
export * from "./riskAndDangerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./riskAndDangerDialog.vue?vue&type=style&index=0&id=480a6072&lang=scss&scoped=true&"
import style1 from "./riskAndDangerDialog.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./riskAndDangerDialog.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a6072",
  null
  
)

export default component.exports